<template lang="html">
    <div>
        <div class="d-flex">
            <!-- Channel -->
            <div class="w-100"><span class="bold">Sales Channel:</span> {{refundChannel(refund)}}</div>
            <!-- Is Request -->
            <div class="w-100"><span class="bold">Is Request:</span> {{refundIsRequest(refund)}}</div>
        </div>

        <div class="d-flex">
            <!-- Payment Method -->
            <div class="w-100"><span class="bold">Payment Method:</span> {{refundPaymentType(refund)}}</div>
            <!-- Type -->
            <div class="w-100"><span class="bold">Type:</span> {{refundType(refund)}}</div>
        </div>

        <div class="d-flex">
            <!-- Reason -->
            <div class="w-100"><span class="bold">Reason:</span> {{refundReason(refund)}}</div>
            <!-- Value -->
            <div v-if="refundValue(refund)" class="w-100"><span class="bold">Value:</span> {{refundValue(refund)}}</div>
        </div>

        <div v-if="treasurerName(refund) || createDate(payment)" class="d-flex">
            <!-- Treasurer -->
            <div v-if="treasurerName(refund)"class="w-100"><span class="bold">Treasurer:</span> {{treasurerName(refund)}}</div>
            <!-- Created On -->
            <div v-if="createDate(payment)" class="w-100"><span class="bold">Created on:</span> {{createDate(payment)}}</div>
        </div>
        
        <div class="d-flex">
            <div class="w-100" v-if="refund.code"><span class="bold">Code:</span> {{refund.code}}</div>
            <div v-if="refundCancelationsReason(refund)" class="w-100"><span class="bold">Reason for refund cancellation: </span> {{refundCancelationsReason(refund)}}</div>
        </div>

        <!-- Refund Items -->
        <div v-if="refund.refundItems.length > 0" class="w-100">
            <span class="bold">Refund items:</span>
            <div>
                <div v-for="refundItem in refund.refundItems" v-if="refundItem.quantity > 0">
                    <div>{{refundItemQtd(refundItem)}}x {{refundItemName(refundItem)}}</div>
                </div>
            </div>
        </div>


        <div 
            v-if="hasButtons"
            class="d-flex justify-content-between mt-2"
        >
            <button v-if="refund.canBeCanceled" :disabled="isLoading" class="btn action " @click="cancelRefunded(refund)">Cancel this refund</button>
            <button v-if="showExecuteBtn" :disabled="isLoading" class="btn blue btnMarkAsRefunded" @click="markAsRefunded(refund)">Mark as refunded</button>
            <button v-if="refund.canBeDeleted" :disabled="isLoading" class="btn action" @click="deleteRefund(refund)">Delete refund</button>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import { dialogMixin } from '@/mixins/dialog';
import refundService from '@/api/reservation/refundService'
import REFUND_STATUS from '@/enums/refundStatus'

export default {
    mixins:[
        dialogMixin,
    ],
    data: function () {
        return {
            isLoading: false
        }
    },
    props: {
        refund: {
            tipe: Object,
            default: null,
            required: true
        },
        payment: {
            tipe: Object,
            default: null,
            required: true
        },
        reservation:{
            type: Object
        },
        isLegacyRefund: {
            type: Boolean,
            default: false
        }
    },
    computed:{
        ...mapGetters([
            'getPaymentTypeListAll',
            'getRefundReasons',
            'getCancelRefundReasons',
            'getSelectedReservation',
        ]),
        showExecuteBtn: function () {
            return  this.refund.id &&
                    this.refund.isRequest == true &&
                    this.refund.isProcessed != true &&
                    this.refund.status == 1 &&
                    ( this.accessPermissionFilter(['admin']) || this.accessPermissionFilter(['mainSupervisor']) )
        },
        hasButtons() {
            return this.refund.canBeCanceled || this.refund.canBeDeleted;
        }
    },
    methods:{
        ...mapActions([
            'selectRefund',
            'openModal',
            'executeRefund',
            'refreshCurrentSelectedReservation',
        ]),
        refundCancelationsReason: function(refund) {
            if (!refund || !refund.refundCancelationReasonType) {
                return null;
            }
            
            const reason = this.getCancelRefundReasons.find(reason => reason.id === refund.refundCancelationReasonType);
            if (!reason) {
                return null;
            }
            
            const { id, text } = reason;
            const { refundCancelationReasonDescription } = refund;
            
            if (id === 0) {
                return `${text} - ${refundCancelationReasonDescription}`;
            }
            
            return text;
        },
        refundChannel: function (refund) {
            return refund.refundChannels[0].brandName
        },
        refundIsRequest: function (refund) {
            return refund.isRequest? 'Yes' : 'No'
        },
        refundPaymentType: function (refund) {
            let foundPyamentMethod =  this.getPaymentTypeListAll.find(pm => pm.id == refund.paymentType)
            return foundPyamentMethod? foundPyamentMethod.description : ' - '
        },
        refundType: function (refund) {
            if(refund.refundItems.length > 0){
                return !this.refund.isToReleaseQuantity ? 'Reduce Quantity' : 'Reduce Quantity (Available Again)'
            } else if(refund.isToRefundTotal == true){
                return 'Total'
            } else {
                let output = refund.amountType == 0? 'Value' : 'Percentage'
                let value = (refund.amount ) + (refund.amountType == 0? '€' : '%')
                return output + ` (${value})`
            }
        },
        refundReason: function (refund) {
            let reasonId = refund.refundReasonType
            if(reasonId == 0){
                return refund.reason != null ? 'Other: ' + refund.reason : ' - no reason provided -'
            } else {
                let foundReason = this.getRefundReasons.find(r => r.id == reasonId)
                return foundReason? foundReason.text : '-'
            }
        },
        refundValue: function (refund) {
            if(!refund.amountResumeValue){
                return null
            }
            return this.formatPrice(refund.amountResumeValue) + '€'
        },
        refundItemQtd: function (refundItem) {
            return refundItem.quantity
        },
        refundItemName: function (refundItem) {
            if(refundItem.bookingGenderPrice){
                return refundItem.bookingGenderPrice.audienceTypeDescription
            } else if(refundItem.bookingComponent){
                return refundItem.bookingComponent.componentName + ' - ' + refundItem.bookingComponent.componentPriceName
            }
        },
        treasurerName: function (refund) {
            return (refund.userAccount && refund.userAccount.name)? refund.userAccount.name : null
        },
        createDate: function(payment) {
            return payment.createdOn? this.formatDateDots(payment.createdOn) + ' ' + this.formatTime(payment.createdOn) : false
        },
        cancelRefunded: function (refund) {
            if(!refund.id){
                // this means that is a unsaved refund
                this.reservation.refunds = this.reservation.refunds.filter(refund => {
                    return refund.id != undefined
                })
            } else {
                this.selectRefund(refund).then(r => {
                    this.openModal('RefundCancel');
                })
            }
        },
        async deleteRefund(refund) {
            if (!this.$confirmDelete('this refund')) return

            await refundService.deleteRefund(refund.id)
            this.refreshCurrentSelectedReservation().then(() => {
                this.eventHub.$emit('updateThisReservation', this.getSelectedReservation);
            });
        },
        markAsRefunded: function (refund) {
            this.$dialog.confirm('<h1>Confirm refund</h1><p class="mt-3">Are you sure you want to confirm this refund?<br><b>This action is irreversible!</b></p>').then(() => {
                this.isLoading = true
                this.executeRefund({
                    refund: refund,
                    reservation: this.reservation
                }).then(() => {
                    this.isLoading = false
                    this.refreshCurrentSelectedReservation().then(() => {
                        this.eventHub.$emit('updateThisReservation', this.getSelectedReservation);
                    });
                }).catch(err => {
                    this.isLoading = false

                })
            }).catch(function () {
                // This will be triggered when user clicks on cancel
            });
        },
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// refund.vue?c8239d7e